import { assign, createMachine, interpret } from 'xstate';
import {
  handleArrive,
  handleDepart,
  handleDie,
  handleEnableGoal,
  handleEnableHeal,
  handleEnableRob,
  handleEnableShop,
  handleEnableWork,
  handleGetHorse,
  handleStartTraveling,
  handleTakeBowl,
  handleWalk
} from './handlers';
import Debug from 'debug';
const debug = Debug('model.party.history.machine');

const game = createMachine({
  id: 'story',
  initial: 'Path',
  context: {
    party: undefined, // Initial context setup
    onChange: undefined // Dynamically set this later
  },
  predictableActionArguments: true,
  states: {
    Path: {
      on: {
        WALK: { actions: handleWalk },
        ARRIVE: { target: 'FirstTown', actions: handleArrive }
      }
    },
    FirstTown: {
      on: {
        TAKE_BOWL: { target: 'CanBeg', actions: handleTakeBowl }
      }
    },
    CanBeg: {
      type: 'parallel',
      states: {
        CanHeal: {
          initial: 'disabled',
          states: {
            disabled: {
              on: {
                ENABLE_HEAL: { target: 'enabled', actions: handleEnableHeal }
              }
            },
            enabled: { type: 'final' }
          }
        },
        CanWork: {
          initial: 'disabled',
          states: {
            disabled: {
              on: {
                ENABLE_WORK: { target: 'enabled', actions: handleEnableWork }
              }
            },
            enabled: { type: 'final' }
          }
        },
        CanRob: {
          initial: 'disabled',
          states: {
            disabled: {
              on: {
                ENABLE_ROB: { target: 'enabled', actions: handleEnableRob }
              }
            },
            enabled: { type: 'final' }
          }
        },
        CanSeeGoal: {
          initial: 'disabled',
          states: {
            disabled: {
              on: {
                ENABLE_GOAL: { target: 'enabled', actions: handleEnableGoal }
              }
            },
            enabled: { type: 'final' }
          }
        },
        CanShop: {
          initial: 'disabled',
          states: {
            disabled: {
              on: {
                ENABLE_SHOP: { target: 'enabled', actions: handleEnableShop }
              }
            },
            enabled: { type: 'final' }
          }
        }
      },
      onDone: 'CityReady'
    },
    CityReady: {
      on: {
        GET_HORSE: { target: 'ReadyToLeave', actions: handleGetHorse }
      }
    },
    ReadyToLeave: {
      on: {
        DEPART: { target: 'Traveling', actions: handleDepart }
      }
    },
    Traveling: {
      entry: handleStartTraveling,
      on: {
        DIE: { target: 'CityReady', actions: handleDie }
      }
    }
  },
  on: {
    // Define a global event to update the context
    UPDATE_CONTEXT: {
      actions: assign({
        // Update context with payload
        onChange: (context, event) => event.onChange
        // You can add more context updates here
      })
    }
  }
});

const Machine = party => {
  const gameWithContext = game.withContext({
    ...game.context,
    party,
    onChange: () => {}
  });

  let currentState = gameWithContext.initialState;

  const updateContext = newContext => {
    service.send({ type: 'UPDATE_CONTEXT', ...newContext });
  };

  // Machine instance with internal state
  const service = interpret(gameWithContext)
    .onTransition(state => {
      if (state.changed) {
        debug(state.value);
        currentState = state;
      }
    })
    .start();

  return {
    currentState,
    updateContext,
    send: e => {
      debug(e);
      const { type, result, context } = e;
      service.send({ type, result, context });
    }
  };
};

export default Machine;
